import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconOrdersSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="24" height="24" viewBox="0 0 24 24" className={classNames(['svg-icon svg-orders', className])}>
            <path className="svg-orders_b" d="M0,0H24V24H0Z" fill="none"/>
            <path className="svg-orders_c" fill={color}
                  d="M4,13a1,1,0,1,0-1-1A1,1,0,0,0,4,13Zm0,4a1,1,0,1,0-1-1A1,1,0,0,0,4,17ZM4,9A1,1,0,1,0,3,8,1,1,0,0,0,4,9Zm4,4H20a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Zm0,4H20a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2ZM7,8A1,1,0,0,0,8,9H20a1,1,0,0,0,0-2H8A1,1,0,0,0,7,8ZM4,13a1,1,0,1,0-1-1A1,1,0,0,0,4,13Zm0,4a1,1,0,1,0-1-1A1,1,0,0,0,4,17ZM4,9A1,1,0,1,0,3,8,1,1,0,0,0,4,9Zm4,4H20a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Zm0,4H20a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2ZM7,8A1,1,0,0,0,8,9H20a1,1,0,0,0,0-2H8A1,1,0,0,0,7,8Z"/>
        </svg>
    );
};

IconOrdersSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconOrdersSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconOrdersSVG;